<template>
  <div class="card-ad-slider">
    <h2 class="card-ad-slider__title">{{ title }}</h2>
    <div class="card-ad-slider__inner">
      <div class="card-ad-slider--show-lg">
        <Carousel :settings="carouselSettings">
          <template #slides>
            <Slide v-for="ad in ads" :key="ad">
              <div class="card-ad-slider__item">
                <div
                  class="card card--annonce m--tile"
                  :class="{ 'm--plus-ad': ad.isPlus }"
                >
                  <CardAd :event-bus="eventBus" v-bind="{ ...ad }"></CardAd>
                </div>
              </div>
            </Slide>
          </template>
          <template #addons="{ slidesCount }">
            <Navigation v-if="slidesCount > 4" />
          </template>
        </Carousel>
      </div>
      <div class="card-ad-slider__scroll-container card-ad-slider--hide-lg">
        <div class="card-ad-slider__item" v-for="ad in ads" :key="ad.id">
          <div
            class="card card--annonce m--tile"
            :class="{ 'm--plus-ad': ad.isPlus }"
          >
            <CardAd :event-bus="eventBus" v-bind="{ ...ad }"></CardAd>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardAd from '@components/CardAd/CardAd.vue'
import { Carousel, Navigation, Slide } from 'vue3-carousel'

import { LogSliderCardAdClicked } from '@/events'

import mitt from 'mitt'

export default {
  name: 'CardAdSlider',
  components: {
    CardAd,
    Carousel,
    Slide,
    Navigation,
  },
  props: {
    ads: { default: null, type: Array },
    title: { default: null, type: String },
  },
  data() {
    return {
      eventBus: mitt(),
      carouselSettings: {
        itemsToShow: 4,
        itemsToScroll: 4,
        wrapAround: true,
        snapAlign: 'start',
      },
    }
  },
  methods: {
    cardAdClicked() {
      LogSliderCardAdClicked()
    },
  },
  created() {
    if (this.eventBus === null || this.eventBus === undefined) return
    this.eventBus.on('card-ad-clicked', this.cardAdClicked)
  },
}
</script>

<style lang="scss">
@import 'CardAdSlider.scss';
@import '../Gallery/Vue3Carousel.css';
</style>
